import * as React from "react"
import { cn } from "@/lib/utils"

export function Table({ className, ...props }: React.HTMLAttributes<HTMLTableElement>) {
  return <table className={cn("w-full border-collapse text-sm", className)} {...props} />
}
export function Thead(props: React.HTMLAttributes<HTMLTableSectionElement>) { return <thead {...props} /> }
export function Tbody(props: React.HTMLAttributes<HTMLTableSectionElement>) { return <tbody {...props} /> }
export function Tr({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) { return <tr className={cn("border-b border-[#1b1b1b] h-[60px]", className)} {...props} /> }
export function Th({ className, ...props }: React.ThHTMLAttributes<HTMLTableCellElement>) { return <th className={cn("bg-muted px-3 py-2 text-left font-medium text-foreground", className)} {...props} /> }
export function Td({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) { return <td className={cn("px-3 py-2 text-foreground/90", className)} {...props} /> }
